export default "__VITE_ASSET__1b5a76b4__"